import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { PrimaryBtnComponent } from 'app/components/ui-kit/buttons/primary-btn/primary-btn.component';
import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';
import { PasswordStrengthInputComponent } from 'app/components/ui-kit/inputs/password-strength-input.component';
import { AlertMessageComponent } from 'app/components/ui-kit/alerts/alert-message/alert-message.component';
import { SpinnerComponent } from 'app/components/ui-kit/loaders/spinner/spinner.component';
import { SplitPageWrapperComponent } from 'app/components/ui-kit/page-components/split-page-wrapper/split-page-wrapper.component';
import { AuthService } from 'app/services/auth.service';
import { ThemeService } from 'app/services/theme.service';
import { BLOCKED_PASSWORDS } from 'app/constants/auth-constants';

@Component({
  selector: 'app-reset',
  standalone: true,
  imports: [CommonModule, FormsModule, SvgLoaderComponent, SplitPageWrapperComponent,
    PasswordStrengthInputComponent, PrimaryBtnComponent, AlertMessageComponent, SpinnerComponent, RouterModule],
  templateUrl: './reset.component.html',
  styleUrl: './reset.component.scss'
})
export class ResetComponent {
  password = '';
  confirmPassword = '';
  oobCode = '';
  errorMessage = '';
  currentTheme: string = '';
  ctaText: string = 'Your AI Assistant for Efficient Private Travel';
  isSubmitting = false;
  resetSuccessful = false;
  countdown = 5;
  private countdownIntervalId: ReturnType<typeof setInterval> | null = null;
  private redirectTimeoutId: ReturnType<typeof setTimeout> | null = null;
  constructor(private authService: AuthService, private route: ActivatedRoute, private themeService: ThemeService, private router: Router) {
    this.currentTheme = this.themeService.getCurrentTheme();
    const oobCode = this.route.snapshot.queryParams['oobCode'];
    if (!oobCode) {
      this.router.navigate(['/forgot']);
      return;
    }
    this.oobCode = oobCode;
  }

  async resetPassword() {
    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Passwords do not match.';
      return;
    }
    if (BLOCKED_PASSWORDS.includes(this.password.toLowerCase())) {
      this.errorMessage = 'This password is too common. Please choose a more secure password.';
      return;
    }
    if (this.password.length < 8) {
      this.errorMessage = 'This password is too weak.';
      return;
    }
    this.isSubmitting = true;
    this.errorMessage = '';
    try {
      await this.authService.confirmPasswordReset(this.oobCode, this.password);
      this.startRedirectCountdown();
    } catch (error) {
      this.errorMessage = 'Failed to reset password.';
    }
    this.isSubmitting = false;
  }

  resetError() {
    this.errorMessage = null;
  }

  private startRedirectCountdown() {
    this.resetSuccessful = true;
    this.countdown = 5;
    this.countdownIntervalId = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0 && this.countdownIntervalId) {
        clearInterval(this.countdownIntervalId);
        this.countdownIntervalId = null;
      }
    }, 1000);
    this.redirectTimeoutId = setTimeout(() => {
      this.router.navigate(['/login']);
    }, 5000);
  }

  loginNow() {
    if (this.countdownIntervalId) {
      clearInterval(this.countdownIntervalId);
    }
    if (this.redirectTimeoutId) {
      clearTimeout(this.redirectTimeoutId);
    }
    this.router.navigate(['/login']);
  }

  ngOnDestroy() {
    if (this.countdownIntervalId) {
      clearInterval(this.countdownIntervalId);
    }
    if (this.redirectTimeoutId) {
      clearTimeout(this.redirectTimeoutId);
    }
  }
}
